<dx-popup
    #apAdjustmentDetailPopup
    [title]="popUpTitle"
    [showTitle]="true"
    [minWidth]="'50%'"
    [minHeight]="'50%'"
    [resizeEnabled]="true"
    [(visible)]="visible"
    (onHidden)="onHidden()"
>
    <div *dxTemplate="let item of 'content'" class="adjustment-detail-content">
        <dx-box *ngIf="!!adjustmentDetail" width="100%" height="100%" direction="col">
            <dxi-item baseSize="auto">
                <dx-form
                    width="100%"
                    height="100%"
                    [readOnly]="true"
                    [colCount]="2"
                    [labelLocation]="defaultLabelLocation"
                    [formData]="adjustmentDetail"
                >
                    <dxi-item [colSpan]="1">
                        <dxo-label text="Adjustment Type"></dxo-label>
                        <div *dxTemplate>
                            {{ adjustmentDetail?.debitOrCredit }}
                        </div>
                    </dxi-item>
                    <dxi-item [colSpan]="1">
                        <div class="history-icon" *dxTemplate>
                            <dx-toolbar>
                                <dxi-item location="after">
                                    <div *dxTemplate>
                                        <app-attachment-editor
                                            [communityId]="communityId"
                                            [attachments]="adjustmentDetail.attachments"
                                            [viewOnly]="true"
                                            (onAttachmentUpdate)="onAttachmentUpdate($event)"
                                        ></app-attachment-editor>
                                    </div>
                                </dxi-item>
                                <dxi-item
                                    *ngIf="isInternalUser"
                                    location="after"
                                    widget="dxButton"
                                    locateInMenu="auto"
                                    [options]="historyButtonOptions"
                                ></dxi-item>
                            </dx-toolbar>
                        </div>
                    </dxi-item>
                    <dxi-item [colSpan]="2">
                        <dxo-label text="Description"></dxo-label>
                        <div *dxTemplate>
                            <dx-text-box [readOnly]="true" [value]="adjustmentDetail?.description"></dx-text-box>
                        </div>
                    </dxi-item>
                    <dxi-item [colSpan]="1">
                        <dxo-label text="Document Date"></dxo-label>
                        <div *dxTemplate>
                            {{ adjustmentDetail?.docDate | date: dateFormat }}
                        </div>
                    </dxi-item>
                    <dxi-item [colSpan]="1">
                        <dxo-label text="Post Date"></dxo-label>
                        <div *dxTemplate>
                            {{ adjustmentDetail?.postDate | date: dateFormat }}
                        </div>
                    </dxi-item>
                    <dxi-item [colSpan]="1">
                        <dxo-label text="Charge"></dxo-label>
                        <div *dxTemplate>
                            {{ adjustmentDetail?.amount | ccCurrency }}
                        </div>
                    </dxi-item>
                    <dxi-item [colSpan]="1">
                        <dxo-label text="Charge Due"></dxo-label>
                        <div *dxTemplate>
                            {{ adjustmentDetail?.openBalance | ccCurrency }}
                        </div>
                    </dxi-item>
                    <dxi-item [colSpan]="1" *ngIf="adjustmentDetail?.vendor?.name">
                        <dxo-label text="Vendor"></dxo-label>
                        <div *dxTemplate>
                            <app-hyperlink-creator
                                actionCode="VENDOR_MANAGEMENT"
                                [displayText]="adjustmentDetail?.vendor?.name"
                                [communityId]="adjustmentDetail?.communityId"
                                (onLinkClick)="onVendorNameClick(adjustmentDetail)"
                            ></app-hyperlink-creator>
                        </div>
                    </dxi-item>
                    <dxi-item [colSpan]="2" *ngIf="adjustmentDetail?.additionalInfoDisplayText">
                        <div *dxTemplate>
                            <span class="cc-text-required">
                                {{ adjustmentDetail?.additionalInfoDisplayText }}&nbsp;
                            </span>
                            <span *ngIf="!!adjustmentDetail?.referenceType">
                                <app-hyperlink-creator
                                    mode="hyperlinkOnly"
                                    [displayText]="adjustmentDetail?.referenceTypeText"
                                    [communityId]="adjustmentDetail?.communityId"
                                    (onLinkClick)="onAdditionalInfoClick(adjustmentDetail)"
                                ></app-hyperlink-creator>
                            </span>
                        </div>
                    </dxi-item>
                </dx-form>
            </dxi-item>
            <dxi-item [ratio]="1" class="adjustment-details-datagrid-content">
                <cc-data-grid-features
                    [stateConfig]="{ storageKey: 'ADJUSTMENT_DETAILS_GRID' }"
                    [gridFeatures]="{ placement: 'top', allowPlacementSwitch: false }"
                    [pagingConfig]="{ visible: false }"
                    [dataSource]="adjustmentDetail?.items"
                >
                    <dx-data-grid
                        width="100%"
                        height="100%"
                        [showBorders]="true"
                        [showRowLines]="true"
                        [showColumnLines]="true"
                        [wordWrapEnabled]="true"
                        [rowAlternationEnabled]="false"
                        [columnAutoWidth]="true"
                        [dataSource]="adjustmentDetail?.items"
                    >
                        <dxi-column
                            caption="Item #"
                            dataType="string"
                            alignment="right"
                            cellTemplate="itemNoTemplate"
                            width="4%"
                            [allowGrouping]="false"
                        ></dxi-column>
                        <dxi-column
                            caption="Account"
                            dataType="string"
                            cellTemplate="accountTemplate"
                            width="30%"
                        ></dxi-column>
                        <dxi-column
                            *ngIf="adjustmentDetail?.entityUsesSubCategory"
                            caption="Sub Category"
                            dataType="string"
                            dataField="subCategory"
                            width="10%"
                        ></dxi-column>
                        <dxi-column
                            caption="Amount"
                            dataType="number"
                            dataField="amount"
                            [format]="currencyFormat"
                            [allowGrouping]="false"
                            width="9%"
                        ></dxi-column>
                        <dxi-column
                            caption="Open Balance"
                            dataType="number"
                            dataField="openBalance"
                            [format]="currencyFormat"
                            [allowGrouping]="false"
                            width="8%"
                        ></dxi-column>

                        <ng-container *ngFor="let dim of adjustmentDetail?.requiredDimensions">
                            <dxi-column
                                [caption]="dim.displayText"
                                dataType="string"
                                [dataField]="dim.key"
                            ></dxi-column>
                        </ng-container>
                        <ng-container *ngIf="hasOtherDimensions">
                            <dxi-column
                                caption="Other Dimensions"
                                dataType="string"
                                cellTemplate="dimensionTemplate"
                                width="15%"
                            ></dxi-column>
                        </ng-container>

                        <dxi-column
                            caption="Description"
                            dataType="string"
                            dataField="description"
                            width="15%"
                        ></dxi-column>
                        <div *dxTemplate="let row of 'itemNoTemplate'">
                            <span>{{ row.rowIndex + 1 }}</span>
                        </div>
                        <div *dxTemplate="let row of 'accountTemplate'">
                            <ng-container *ngIf="row.data.accountLabelTitle">
                                Account Label:
                                <strong>{{ row.data.accountLabelTitle }}</strong>
                                <br />
                                GL Account Number:
                                <strong>{{ row.data.glAccountNumberTitle }}</strong>
                                <br />
                                Offset GL Account:
                                <strong>{{ row.data.offsetGLAccountNumberTitle }}</strong>
                            </ng-container>
                            <ng-container *ngIf="!row.data.accountLabelTitle">
                                GL Account Number:
                                <strong>{{ row.data.glAccountNumberTitle }}</strong>
                                <br />
                                Offset GL Account:
                                <strong>{{ row.data.offsetGLAccountNumberTitle }}</strong>
                            </ng-container>
                        </div>

                        <div *dxTemplate="let row of 'dimensionTemplate'">
                            <ng-container *ngFor="let dim of row.data.dimensions">
                                <ng-container *ngIf="isNotRequiredDimension(dim)">
                                    {{ dim.dimensionTitle }}: {{ dim.dimensionOptionTitle }}
                                    <br />
                                </ng-container>
                            </ng-container>
                        </div>

                        <dxo-summary [calculateCustomSummary]="calculateCustomSummary">
                            <dxi-total-item
                                name="amount"
                                showInColumn="amount"
                                summaryType="custom"
                                dataType="number"
                                displayFormat="Total: {0}"
                                [valueFormat]="currencyFormat"
                            ></dxi-total-item>
                        </dxo-summary>
                    </dx-data-grid>
                </cc-data-grid-features>
            </dxi-item>
            <dxi-item baseSize="auto">
                <dx-toolbar width="100%">
                    <dxi-item location="after" *ngIf="adjustmentDetail?.allowApplyDebit">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                text="Apply Debit"
                                [icon]="iconCheck"
                                (onClick)="onApplyDebitClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item
                        location="after"
                        *ngIf="!adjustmentDetail?.allowEdit && adjustmentDetail?.allowLimitedEdit"
                    >
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                text="Basic Edit"
                                [icon]="iconEdit"
                                (onClick)="onEditAdjustmentClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>

                    <dxi-item location="after" *ngIf="adjustmentDetail?.allowEdit">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                text="Edit"
                                [icon]="iconEdit"
                                (onClick)="onEditAdjustmentClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item location="after" *ngIf="adjustmentDetail?.allowReverse">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                text="Reverse"
                                hint="Reverse"
                                [icon]="iconReverse"
                                (onClick)="onReverseClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item location="after" *ngIf="adjustmentDetail?.allowDelete">
                        <div *dxTemplate>
                            <dx-button
                                type="danger"
                                text="Delete"
                                hint="Delete"
                                [icon]="iconTrash"
                                (onClick)="onDeleteAdjustment()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item location="after" *ngIf="adjustmentDetail?.hasCreditApplications">
                        <div *dxTemplate>
                            <app-hyperlink-creator
                                cssClass="cc-hyper-link"
                                mode="hyperlinkOnly"
                                displayText="Payment Applications"
                                [communityId]="adjustmentDetail?.communityId"
                                (onLinkClick)="onPaymentApplicationClick(adjustmentDetail)"
                            ></app-hyperlink-creator>
                        </div>
                    </dxi-item>

                    <dxi-item location="before">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                text="Close"
                                [icon]="iconClose"
                                (onClick)="onHidden()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                </dx-toolbar>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#apAdjustmentDetailPopup' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>

<app-transaction-history
    *ngIf="displayTransactionLogPopUp"
    [title]="transactionLogTitle"
    [transactionLogResultData]="transactionLogResultData"
    [communityId]="communityId"
    (onTransactionLogClose)="onTransactionLogClose($event)"
></app-transaction-history>

<app-ap-adjustment-editor
    #apAdjustmentEditor
    [visible]="showEditAdjustment"
    [managementCompanyId]="adjustmentDetail?.managementCompanyId"
    [communityId]="adjustmentDetail?.communityId"
    [apAdjustmentId]="adjustmentDetail?.apAdjustmentId"
    (onClose)="onEditorClose($event)"
></app-ap-adjustment-editor>

<app-ap-reverse
    *ngIf="showReverseAdjustment"
    [title]="reverseAPTitle"
    [reverseEditorData]="reverseEditorData"
    (onReverse)="onReverseAdjustment($event)"
    (onClose)="onReverseAdjustmentClose()"
></app-ap-reverse>

<app-apply-adjustment-debit
    *ngIf="showApplyDebitEditor"
    [communityId]="adjustmentDetail?.communityId"
    [managementCompanyId]="adjustmentDetail?.managementCompanyId"
    [transactionId]="adjustmentDetail?.apAdjustmentId"
    [requiredDimensionOptions]="requiedDimensionOptionCodes"
    (onClose)="onApplyDebitClose($event)"
></app-apply-adjustment-debit>

<app-ap-credit-application
    *ngIf="showCreditApplication"
    [visible]="showCreditApplication"
    [creditApplicationData]="creditApplicationData"
    [transactionType]="transactionType"
    [communityId]="adjustmentDetailParam.communityId"
    [popupTitle]="creditApplicationTitle"
    [managementCompanyId]="adjustmentDetailParam.managementCompanyId"
    (onCreditApplicationClose)="closeCreditApplication($event)"
></app-ap-credit-application>

<app-dimension-selector
    *ngIf="showRequiredDimensionSelector"
    [visible]="showRequiredDimensionSelector"
    [requiredDimensions]="adjustmentDetail?.glDimensions"
    (onSelect)="onDimensionSelect($event)"
></app-dimension-selector>
